import { Decoration_Type } from "./../../ricos-types/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const getUrlLinkData = TiptapContentResolver.create((content) => {
  if (Array.isArray(content)) {
    const node = content.find((node2) => {
      return node2.type.name === "text";
    });
    if (node?.marks.some((mark) => mark.type.name === Decoration_Type.LINK)) {
      return node.marks[0].attrs.link;
    }
  }
  return false;
});
export {
  getUrlLinkData
};
//# sourceMappingURL=get-url-link-data.js.map
